import { gql } from "@apollo/client";

export const GET_DASHBOARD_TASKS = gql`
  query GetDashboardTasks {
    task {
      id
      type
      status
      createdAt
      name
      description
      meta
      booking {
        id
      }
      lead {
        id
        firstName
        lastName
        email
        phone
      }
      message {
        id
        lead {
          id
          firstName
          lastName
          email
          phone
        }
        toLead {
          id
          firstName
          lastName
          email
          phone
        }
        booking {
          id
        }
      }
    }
  }
`;

export const GET_DASHBOARD_CATALOG = gql`
  query GetDashboardCatalog {
    boats {
      id
      name
    }
    staffList {
      id
      firstName
      lastName
      email
      role
    }
    cateringEnum: __type(name: "Catering") {
      enumValues {
        name
      }
    }
    eventEnum: __type(name: "EventType") {
      enumValues {
        name
      }
    }
    quoteTypeEnum: __type(name: "QuoteType") {
      enumValues {
        name
      }
    }
  }
`;

export const GET_DASHBOARD_CONVERSATION = gql`
  query GetDashboardConversation($leadID: UUID!) {
    messagesByLead(leadID: $leadID) {
      id
      content
      createdAt
      seenOn
      status
      type
      toName
      toAddress
      lead {
        id
        firstName
        lastName
        email
      }
      toLead {
        id
        firstName
        lastName
        email
      }
      owner {
        id
        firstName
        lastName
        email
      }
      toOwner {
        id
        firstName
        lastName
        email
      }
      booking {
        id
        reference
      }
      bookingOption {
        id
        reference
      }
      quote {
        id
        reference
      }
    }
  }
`;

export const GET_DASHBOARD_BOOKING_DETAIL = gql`
  query GetDashboardBookingDetail($id: UUID!) {
    booking(id: $id) {
      id
      reference
      createdAt
      cruiseDate
      hours
      groupSize
      catering
      event
      eventOther
      source
      notes
      available
      lastStatus
      lastStatusSetOn
      availabilityCheckSentOn
      reviewRequestSentOn
      lead {
        id
        firstName
        lastName
        email
        phone
      }
      items {
        id
        baseCost
        commision
        boat {
          id
          name
          skipperRequired
          owner {
            id
            firstName
            lastName
            email
            phone
          }
        }
        boatPackage {
          id
          name
        }
        skippers {
          id
          staff {
            id
            firstName
            lastName
            role
          }
        }
        deckies {
          id
          staff {
            id
            firstName
            lastName
            role
          }
        }
      }
      options {
        id
        reference
        message
        sentOn
        seenOn
        items {
          price
          hours
          bookingItem {
            id
            boat {
              id
              name
            }
            boatPackage {
              id
              name
            }
          }
        }
      }
      quotes {
        id
        reference
        type
        sentOn
        seenOn
        expired
        reminderSentOn
        finalPaymentReminderSentOn
        waiverSignOn
        waiver {
          id
          name
          content
        }
        items {
          id
          baseCost
          commision
          bookingItem {
            id
            boat {
              id
              name
            }
            boatPackage {
              id
              name
            }
          }
          costs {
            id
            description
            type
            cost
            commision
            pickUpWharf {
              id
              name
            }
            dropOffWharf {
              id
              name
            }
            package {
              id
              name
            }
          }
        }
        transactions {
          id
          createdAt
          paid
          total
          paymentFees
          tax
          taxMode
        }
      }
    }
  }
`;
